// © Microsoft Corporation. All rights reserved.

/**
 * Enum for different page types
 * @enum
 */
export enum PageType {
    Article = "article",
    ArticleFullScreen = "articlefullscreen",
    DHP = "dhp",
    Gallery = "gallery",
    GalleryFullScreen = "galleryfullscreen",
    Launcher = "launcher",
    MMX = "mmx",
    NewsAndInterests = "newsandinterestshp",
    Newsbar = "newsbar",
    NewsbarUpsell = "newsbarupsell",
    NTP = "ntp",
    Story = "story",
    Shopping = "shopping",
    ShoppingDealsCategory = "shopping::deals-category",
    ShoppingPlus = "shopping::plus",
    ShoppingProductDetails = "shopping::product",
    ShoppingStoreCoupons = "shopping::store-coupons",
    ShoppingStyles = "shopping::styles",
    Video = "video",
    Windows = "windowshp",
    WindowsShellHP = "windowsshellhp"
}

/** The AudienceMode enum */
export enum AudienceModeType {
    Adult = "adult",
    Enterprise = "enterprise",
    Kids = "kids"
}